export function accomodationTypeRedirect(req, res) {
    const pathname = req.url.pathname;
    const patterns = [
        'wohnungspreise',
        'hauspreise',
        'grundstueckspreise',
        'mietspiegel',
        'hausmieten',
    ];
    for (const pattern of patterns) {
        if (pathname.endsWith(`/${pattern}`) || pathname.endsWith(`/${pattern}/`)) {
            const newPathname = pathname.replace(new RegExp(`/${pattern}/?$`), '');
            return res.redirect(newPathname, 301);
        }
    }
}
